import React, { useState, useEffect, useCallback } from "react";
import { Box, IconButton, Tab, ThemeProvider, Tooltip } from "@mui/material";
import {
  DOCUMENT_TYPES,
  fetchDocumentNumber,
  fetchUnitOptionsForItems,
  getDocumentConfig,
  MODIFICATION_TYPES,
  STOCK_TRANSFER_CONFIG,
  theme,
  tooltipContent,
} from "../config/DocumentConfig";
import { HelpOutline } from "@mui/icons-material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Loader, Printer, Save, View } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import useApi from "../../hooks/useApi";
import { getTodayDate } from "../../utils/constants";
import { stockTransferInData } from "../salesInvoice/data";
import { calculateStockTransferInRow as calculateRowValues, BRANCH_TRANSFER_MARGIN_PERCENT } from "../config/StockTransferInTableConfig";
import TimelineTab from "../salesInvoice/TimelineTab";
import ModificationCommentModal from "../salesInvoice/ModificationCommentModal";
import Modal from "../common/CommonModal";
import SummaryTotalCard from "../salesInvoice/SummaryTotalCard";
import ConfigCard from "../salesInvoice/ConfigCard";
import { getWorkOrderVatPercent } from "../config/WorkOrderTableConfig";
import ModeIndicator from "../salesInvoice/ModeIndicator";
import StockTransferInGeneral from "./StockTransferInGeneral";
import BranchTransferDocListModal from "./BranchTransferDocListModal";
import StockTransferInTable from "./StockTransferInTable";
import JobCodeList from "../common/JobCodeList";
import CreditCustomerList from "../common/CreditCustomerList";
import checkIfUserHasAccess from "../common/UserCheckAccess";
import FloatingItemInformation from "../salesInvoice/FloatingItemInformation";

const StockTransfer = ({ documentType = DOCUMENT_TYPES.STOCKTRANSFERIN }) => {
  const transferConfig = STOCK_TRANSFER_CONFIG[documentType];

  const location = useLocation();
  const navigate = useNavigate();
  const { request } = useApi();
  const config = getDocumentConfig(documentType);

  const DEPARTMENT =
    localStorage.getItem("currentSelectedDepartment") || "MAIN";
  const COMPANY_CODE = localStorage?.getItem("companyCode") || "DOODDEMO";
  const CURRENT_USER = localStorage?.getItem("currentUserName") || "admin";
  let API_PATHS = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";
  const BASE_URL = API_PATHS[0]?.API_CONFIG || "https://cubixweberp.com:213";
  const CURRENT_USER_OBJECT = localStorage.getItem("currentUser")
    ? JSON.parse(localStorage.getItem("currentUser"))
    : "";
  const INVMETHOD = CURRENT_USER_OBJECT[0]?.invMethod;
  const defaultLocation = localStorage.getItem("departmentLocation") || "A";


  const todayDate = getTodayDate();
  const documentNoFromState = location?.state?.docNo || null;
  const modeFromState = location?.state?.mode || "new";
  const transferredData = location?.state;
  // console.log("Transferred Data to Sample Issue:", transferredData);


  const [isSaving, setIsSaving] = useState(false);
  const [mode, setMode] = useState(modeFromState);

  const [parentTabValue, setParentTabValue] = useState("1");
  const [supplierData, setSupplierData] = useState(null);
  const [items, setItems] = useState(stockTransferInData);
  console.log("items after state", items)
  const [currentLocation, setCurrentLocation] = useState(defaultLocation);
  const [showSidebar, setShowSidebar] = useState(false);
  const [initialRowUnitOptions, setInitialRowUnitOptions] = useState({});
  const [locationList, setLocationList] = useState([]);
  const [glSettings, setGlSettings] = useState([]);

  const [discountAmount, setDiscountAmount] = useState("");
  const [roundOff, setRoundOff] = useState("");

  const [autoVatIsOn, setAutoVatIsOn] = useState(true);
  const [vatAmountManual, setVatAmountManual] = useState(null);
  const [transferModalOpen, setIsTransferModalOpen] = useState(false);
  const [isModificationModalOpen, setIsModificationModalOpen] = useState(false);

  const [drAccount, setDrAccount] = useState("");
  const [drDesc, setDrDesc] = useState("");
  const [crAccount, setCrAccount] = useState("");
  const [crDesc, setCrDesc] = useState("");
  const [cosAccount, setCosAccount] = useState("");
  const [incomeAccount, setIncomeAccount] = useState("");
  const [modalState, setModalState] = useState({
    isOpen: false,
    type: "", // 'add', 'edit', 'list', 'cr-list','cash-list'
    customer: null,
  });
  const [branchTransferRef, setBranchTransferRef] = useState({
    troutNo: "",   // saved as tr_refno
    originDept: "", // saved as origin
  });
  const [focusedProductCode, setFocusedProductCode] = useState(null);
  const [currentStockInhand, setCurrentStockInhand] = useState(null);
  const [itemPricing, setItemPricing] = useState({ blockPrice: 0, costAvg: 0 });


  const handleParentTabChange = (event, newValue) => {
    setParentTabValue(newValue);
  };
  const closeModal = () => {
    setModalState({
      isOpen: false,
      type: "",
      customer: null,
    });
  };
  const [documentData, setDocumentData] = useState({
    documentNo: "",
    date: todayDate,
    proposalNo: "",
    salesperson: "",
    salespersonId: "",
    salespersonAcc: "",
    salespersonAccDesc: "",
    customer: "",
    customerAcc: "",
    remarks: "",
    discountAmount: 0,
    roundOff: 0,
    taxableAmount: 0,
    vatAmount: 0,
    grossAmount: 0,
    netAmount: 0,
    bcAmt: 0,
    vatStatus: "",
    vatPercent: 0,
    approval: "Pending",
    currentStatus: "Normal",
    cordinatorid: "",
    cordinatorName: "",
    job: "",
    requestedBy: "",
    costCenter: "",
    marginPercent: 0,
    documentType,
  });
  const [showBranchTransferModal, setShowBranchTransferModal] = useState(false);
  // Handle branch transfer doc selection
  const handleBranchTransferSelected = (row, fetchedItems) => {
    console.log("Modal data from branch transfer in", fetchedItems)
    // Store the ref fields for the save payload
    setBranchTransferRef({
      troutNo: row.TROUT_NO || "",
      originDept: row.DEPTNO?.trim() || "",
    });
    // Set Source Department in the form
    setDocumentData((prev) => ({
      ...prev,
      customer: row.DEPTNO?.trim() || "",
    }));

    // Map fetched line items into the grid
    const mappedItems = fetchedItems.map((item, idx) => ({
      id: idx + 1,
      sino: idx + 1,
      code: item.code || "",
      description: item.idesc || "",
      location: currentLocation,
      unit: item.unit || "PCS",
      qty: Number(item.tr_qty) || 0,
      unitCost: Number(item.unit_price) || 0,
      unitPrice: Number(item.unit_price) || 0,
      discountPercent: Number(item.discount) || 0,
      amount: Number(item.line_total) || 0,
      fraction: item.fraction != null ? String(item.fraction) : "1",
      vatPercent: Number(item.bcdisc) || 0,
      cntrl: item.soGuid || "",
      oem: "",
    }));

    setItems(mappedItems);
  };



  const calculateTotals = () => {
    const round = (val) => Math.round(Number(val) * 100) / 100;

    const processedItems = items.map((item) =>
      calculateRowValues(item, documentData, {
        items,
      }),
    );
    console.log("Items Data in Totals", processedItems)

    const rowTaxableSum = round(
      processedItems.reduce(
        (sum, item) => sum + (Number(item.billedAmount) || 0),
        0,
      ),
    );

    const rowVatSum = round(
      processedItems.reduce(
        (sum, item) => sum + (Number(item.vatAmount) || 0),
        0,
      ),
    );
    const grossAmount = round(
      processedItems.reduce((sum, item) => sum + (Number(item.total) || 0), 0),
    );

    const globalDiscount = Number(discountAmount) || 0;
    const roundOffValue = Number(roundOff) || 0;

    const taxableAmount = round(rowTaxableSum - globalDiscount - roundOffValue);

    const totalVat =
      !autoVatIsOn && vatAmountManual !== null
        ? round(vatAmountManual)
        : rowVatSum;

    const totalAmount = round(taxableAmount + totalVat);

    const netAmount = round(totalAmount);

    const currencyRate = Number(documentData.currencyRate) || 1;
    const bcAmt = round(netAmount * currencyRate);

    const costAmountTotal = round(
      processedItems.reduce((sum, item) => sum + (Number(item.amount) || 0), 0),
    );

    const simpleTotal = round(
      processedItems.reduce((sum, item) => sum + (Number(item.unitPrice) * Number(item.qty) || 0), 0),
    );

    return {
      grossAmount: grossAmount.toFixed(2),
      taxableAmount: taxableAmount.toFixed(2),
      vatAmount: totalVat.toFixed(2),
      discountAmount: globalDiscount.toFixed(2),
      roundOff: roundOffValue.toFixed(2),
      netAmount: netAmount.toFixed(2),
      bcAmt: bcAmt.toFixed(2),
      costAmountTotal: costAmountTotal.toFixed(2),
      simpleTotal: simpleTotal.toFixed(2),
    };
  };

  const totals = calculateTotals();

  // Auto-fill from transferred data (QuotationDrawer state)
  useEffect(() => {
    if (transferredData?.proposalNumber && transferredData?.sampleIssueData) {
      const { proposalNumber, sampleIssueData, selectedItems } =
        transferredData;

      // Auto-fill documentData with sample issue data
      setDocumentData((prev) => ({
        ...prev,
        proposalNo: proposalNumber || "",
        customer: sampleIssueData?.customer || "",
        customerAcc: sampleIssueData?.cust_acc || "",
        salesperson: sampleIssueData?.salesperson || "",
        salespersonId: sampleIssueData?.salespersonId || "",
        salespersonAcc: sampleIssueData?.salespersonAcc || "",
        salespersonAccDesc: sampleIssueData?.salesPersonAccDesc || "",
        date: sampleIssueData?.date || todayDate,
        cordinatorid: sampleIssueData?.cordinatorId || "",
        cordinatorName: sampleIssueData?.cordinatorName || "",
      }));

      // Auto-fill Dr Account with salespersonAcc
      setDrAccount(sampleIssueData?.salespersonAcc || "");
      setDrDesc(sampleIssueData?.salesPersonAccDesc || "");

      // Auto-fill items from selected quotation items
      if (selectedItems && selectedItems.length > 0) {
        const mappedItems = selectedItems.map((item, index) => ({
          id: Date.now() + index,
          sino: index + 1,
          code: item.Code || "",
          description: item.Description || "",
          qty: Number(item.Sample_Qty) || 0,
          unit: item.Unit || "PCS",
          unitPrice: Number(item.unitPrice) || 0,
          discountPercent: Number(item.discountPercent) || 0,
          amount: Number(item.amount) || 0,
          fraction: item.fraction || "1",
          vatPercent: Number(item.vatPercent) || 5,
          vatAmount: Number(item.vatAmount) || 0,
          total: Number(item.total) || 0,
          location: item.locn || "A",
          oem: item.oem || "",
          status: item.Status || "",
          cntrl: item.soUid || "",
        }));

        setItems(mappedItems);
      }

      console.log("Auto-filled documentData and items from transfer state");
    }
  }, [transferredData, todayDate]);

  const fetchGLSettings = useCallback(async () => {
    const url = `${BASE_URL}/api/CRMGLSettings/${COMPANY_CODE}/SCRN_CODE/${transferConfig.apiPath}/-/${DEPARTMENT}/-`;

    try {
      const response = await request({
        url,
        method: "GET",
        timeout: 10000,
      });

      const settings = response || [];
      setGlSettings(settings);

      // const dr = settings.find(
      //   (item) => item.Scrn_code === transferConfig.glSettingKeys.debit,
      // );
      // const cr = settings.find(
      //   (item) => item.Scrn_code === transferConfig.glSettingKeys.credit,
      // );

      if (documentType === DOCUMENT_TYPES.BRANCH_TRANSFER) {
        setDrAccount("");
        setDrDesc("");
        const cosAccount = settings.find(
          (item) => item.Scrn_code === "SI-COG-D",
        );
        const incomeAccount = settings.find(
          (item) => item.Scrn_code === "SI-CR-C",
        );
        const stkAcc = settings.find(
          (item) => item.Scrn_code === "SI-STK-C",
        );
        setCosAccount(cosAccount?.ACCOUNT || "");
        setIncomeAccount(incomeAccount?.ACCOUNT || "")
        setCrAccount(stkAcc?.ACCOUNT || "")
        setCrDesc(stkAcc?.accdesc || "")
      }
      if (documentType === DOCUMENT_TYPES.BRANCH_TRANSFER_IN) {
        const brInAccount = settings.find(
          (item) => item.Scrn_code === "BT-IN-C",
        );
        setCrAccount(brInAccount?.ACCOUNT || "")
        setCrDesc(brInAccount?.accdesc || "")
        const stkAcc = settings.find(
          (item) => item.Scrn_code === "BT-IN-D",
        );
        setDrAccount(stkAcc?.ACCOUNT || "")
        setDrDesc(stkAcc?.accdesc || "")

      } else {
        // setDrAccount(dr?.ACCOUNT || "");
        // setDrDesc(dr?.accdesc || "");
      }

      // setCrAccount(cr?.ACCOUNT || "");
      // setCrDesc(cr?.accdesc || "");
    } catch (error) {
      console.error("Failed to fetch GL settings", error);
      setGlSettings([]);
      setDrAccount("");
      setDrDesc("");
      setCrAccount("");
      setCrDesc("");
    }
  }, [BASE_URL, COMPANY_CODE, DEPARTMENT, transferConfig, documentType]);

  useEffect(() => {
    if (mode === "new") {
      fetchGLSettings();
    }
  }, [mode, fetchGLSettings]);

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const url = `${BASE_URL}/api/CpaysCount/${COMPANY_CODE}/LOCATONLIST_ALL/${DEPARTMENT}/-`;
        const res = await request({ url, method: "GET", timeout: 10000 });
        setLocationList(res || []);
      } catch (_) { }
    };
    fetchLocations();
  }, [BASE_URL, COMPANY_CODE, DEPARTMENT]);

  const fetchMarginPercent = useCallback(async () => {
    const url = `${BASE_URL}/api/CpaysCount/${COMPANY_CODE}/DEPTLIST/${DEPARTMENT}/-`;
    try {
      const response = await request({
        url,
        method: "GET",
        timeout: 10000,
      });
      if (Array.isArray(response) && response.length > 0) {
        const deptInfo = response[0];
        const marginVal = Number(deptInfo?.pinvapr) || 0;
        setDocumentData((prev) => ({
          ...prev,
          marginPercent: marginVal,
        }));
        console.log("Fetched margin percentage:", marginVal);
      }
    } catch (error) {
      console.error("Failed to fetch margin percentage", error);
    }
  }, [BASE_URL, COMPANY_CODE, DEPARTMENT]);

  useEffect(() => {
    if (mode === "new") {
      fetchMarginPercent();
    }
  }, [fetchMarginPercent]);

  // useEffect(() => {
  //   if (documentData.salespersonAcc) {
  //     setDrAccount(documentData.salespersonAcc);
  //   }
  // }, [documentData.salespersonAcc]);

  const handleCreditCustomerSelect = (item) => {
    if (!modalState?.target) {
      closeModal();
      return;
    }

    if (modalState.target === "dr") {
      setDrAccount(item.ACCOUNT);
      setDrDesc(item.DESCRIPTION || item.DESCRIPTION || "");
    } else if (modalState.target === "cr") {
      setCrAccount(item.ACCOUNT);
      setCrDesc(item.DESCRIPTION || item.DESCRIPTION || "");
    }

    closeModal();
  };

  const handleSave = async () => {
    try {
      setIsSaving(true);

      // Validate items
      const filteredItems = items.filter(
        (item) => item.code && item.code.trim() !== "",
      );

      if (filteredItems.length === 0) {
        alert("Please add at least one item to the stock transfer");
        setIsSaving(false);
        return;
      }

      // Determine cap value based on document type
      const capValue =
        documentType === DOCUMENT_TYPES.STOCKTRANSFEROUT ? "OT" :
          documentType === DOCUMENT_TYPES.BRANCH_TRANSFER ?
            "BO" :
            documentType === DOCUMENT_TYPES.BRANCH_TRANSFER_IN ?
              "BI" :
              "IN";
      // Calculate margin and billedPrice for each item before building payload
      const processedFilteredItems = filteredItems.map((item) =>
        calculateRowValues(item, documentData, { items })
      );
      console.log("Items Data in Payload", processedFilteredItems);
      // Map line items to payload format
      const lineItemsPayload = processedFilteredItems.map((item, index) => ({
        Slno: index + 1,
        code: item.code || "",
        description: item.description || "",
        locn: item.location || "A",
        unit: item.unit || "PCS",
        qty: Number(item.qty) || 0,
        "Unit Price": Number(item.billedPrice?.toFixed(2)) || 0, //Billed price
        "Disc%": Number(item.discountPercent) || 0,
        Ldisc_amt:
          Number(item.qty) *
          Number(item.unitPrice) *
          (Number(item.discountPercent) / 100) || 0,
        Amount: Number(item.amount?.toFixed(2)) || 0,
        x: "",
        cntrl: item.cntrl || "",
        Fraction: Number(item.fraction) || 1,
        "vat%": Number(item.vatPercent) || 0,
        "Unit Cost": documentType === DOCUMENT_TYPES.BRANCH_TRANSFER_IN ? (Number(Number(item.unitPrice).toFixed(3)) || 0) : (Number(Number(item.unitCost).toFixed(3)) || 0),
        dono: "0",
        sono: "0",
        quotno: "0",
        Avlqty: "0",
        Vatamt: Number(item.vatAmount) || 0,
        BDiscsplit: "0",
        total: Number(item.total?.toFixed(2)) || 0,
        oem: item.oem || "",
        Bin: "",
        rcvd_mode1: "",
        rcvd_mode1_acc: "",
        rcvd_mode1_amt: ((Number(item.unitCost) * Number(item.margin || 0)) / 100)?.toFixed(2) || 0, //margin
        rcvd_mode2: "",
        rcvd_mode2_acc: "",
        rcvd_mode2_amt: item.margin?.toFixed(2) || "",
        commi_acc_Dr: "",
        commi_acc_Cr: "",
        commi_amt: 0,
        shipping_type: "",
        shipping_amt: 0,
      }));

      // Build final payload - each item gets full master data
      const finalPayload = lineItemsPayload.map((item) => ({
        cmpcode: COMPANY_CODE,
        modeop: mode === "edit" ? "EDIT" : "SAVE",
        cashcustomer: "",
        inv_no: documentData.documentNo || "",
        cust_acc: drAccount || "",
        inv_total: totals.netAmount || "0.00",
        inv_cost: documentType === DOCUMENT_TYPES.BRANCH_TRANSFER_IN ? (totals.netAmount || "0.00") : totals.costAmountTotal,
        jv_num: "0",
        comments: documentData.remarks || "",
        disc_amt: discountAmount || "0",
        sale_man: documentData.salespersonId || "",
        lpo_no: documentData.proposalNo || "",
        do_no: "0",
        due_date: documentData.date || todayDate,
        area_code: "",
        type: documentType === DOCUMENT_TYPES.STOCKTRANSFEROUT
          ? "O" : documentType === DOCUMENT_TYPES.BRANCH_TRANSFER
            ? "O" : "I",
        do_data: documentData.requestedBy || "",
        q_no: "0",
        inv_type: "",
        user_id: CURRENT_USER,
        fdisc_amt: "0",
        costc: documentData.costCenter || "",
        job_code: documentData.job || "",
        inv_fctota: totals.netAmount || "0.00",
        fc: documentData.currency || 'AED',
        awb: "",
        blno: "",
        pkg: "",
        rate2: "0",
        rate: 1,
        invcurr: "",
        supl_code: incomeAccount || "", //income account SI-CR-C
        status: "",
        tr_refno: branchTransferRef.troutNo || "",   // TROUT_NO from selected doc
        payment: "",
        manuf: "",
        origin: branchTransferRef.originDept || "", //DEPT
        shipment: "",
        delivery: "",
        packing: "",
        netwt: "",
        grosswt: "",
        insurance: "",
        custom: "",
        validity: "",
        foot1: "",
        frdet: "",
        fruprice: "0",
        framt: "0",
        fob: "",
        repeat: "",
        comm: "0",
        date_paid: documentData.date || todayDate,
        commdue: "0",
        comm_paid: "0",
        commp: "0",
        // type_no: crAccount || "",
        type_no: "",
        paid_amt: "0",
        client_pd: documentData.vatStatus || "",
        tel: "",
        custref: "",
        terms: "0",
        deptno: DEPARTMENT,
        month: "",
        cashcred: "",
        inv_date: documentData.date || todayDate,
        so_no: "0",
        sys_date: todayDate,
        comm_pd_dt: documentData.date || todayDate,
        pump: "",
        governor: "",
        feedpump: "",
        injector: "",
        starter: "",
        enginetype: "",
        date_prom: documentData.date || todayDate,
        date_delvd: documentData.date || todayDate,
        inv_qty: "0",
        rcvd_amt: "0",
        time: "",
        lab_charge: "0",
        oth_charge: 0,
        s: documentType === DOCUMENT_TYPES.BRANCH_TRANSFER ? INVMETHOD : "", //cos as method
        m: "0",
        d: "0",
        e: "0",
        w: "0",
        wa: "0",
        pgroup: "",
        upd: "",
        do_date: documentData.date || todayDate,
        lpo_date: documentData.date || todayDate,
        vehicleno: "",
        drivername: "",
        deliv_site: "",
        head1: documentType === DOCUMENT_TYPES.BRANCH_TRANSFER ? cosAccount : "", //SI-COG-D
        cap: capValue,
        salesacc: crAccount || "",
        salesAccDesc: crDesc || "",
        ...item,
      }));
      console.log("Stock Transfer Payload to save:", finalPayload);
      // return
      const apiUrl = `${BASE_URL}${config.apiEndpoints.save}`;

      const response = await request({
        url: apiUrl,
        method: "POST",
        data: finalPayload,
        timeout: 10000,
      });

      console.log("API Response:", response);

      // Handle success response
      if (response && response.result === "Saved") {
        const transferNumber = response.invoiceNo;
        alert(`${documentType} ${transferNumber} saved successfully!`);
        navigate(documentType === DOCUMENT_TYPES.STOCKTRANSFEROUT
          ? "/sample_issue_list"
          : documentType === DOCUMENT_TYPES.BRANCH_TRANSFER
            ? "/branch_transfer_list"
            : documentType === DOCUMENT_TYPES.BRANCH_TRANSFER_IN
              ? "/branch_transfer_in_list"
              : "/stock_transfer_in_list");
      } else if (response && response.result) {
        alert(`${documentType} saved successfully!`);
        navigate(documentType === DOCUMENT_TYPES.STOCKTRANSFEROUT
          ? "/sample_issue_list"
          : documentType === DOCUMENT_TYPES.BRANCH_TRANSFER
            ? "/branch_transfer_list"
            : documentType === DOCUMENT_TYPES.BRANCH_TRANSFER_IN
              ? "/branch_transfer_in_list"
              : "/stock_transfer_in_list");
      } else {
        alert(
          `Failed to save ${documentType}: ${response?.message || "Unknown error"
          }`,
        );
      }
    } catch (error) {
      console.error("Error saving Stock Transfer:", error);
      alert("Error saving Stock Transfer: " + error.message);
    } finally {
      setIsSaving(false);
    }
  };

  const handlePrint = () => { };
  const fetchDocumentDetail = async (documentNo) => {
    try {
      const url = config.apiEndpoints.detail(
        COMPANY_CODE,
        documentNo,
        DEPARTMENT,
      );
      const fullUrl = `${BASE_URL}${url}`;
      const response = await request({ url: fullUrl, method: "GET" });

      if (response && response.length > 0) {
        const main = response[0];
        console.log("Fetched Sample Issue detail:", main);

        setDocumentData((prev) => ({
          ...prev,
          documentNo: String(
            main[config.fieldMappings.documentNo] || main.inv_no || "",
          ),
          proposalNo: main.lpo_no || main.Expr3 || "",
          customer: main.custref || "",
          customerAcc: main.type_no || "",
          salesperson: main.sale_man || "",
          salespersonId: main.sale_man || "",
          salespersonAcc: main.salesacc || "",
          salespersonAccDesc: main.salesAccDesc || "",
          date: main.inv_date ? main.inv_date.slice(0, 10) : todayDate,
          vatStatus: main.deliv_site || prev.vatStatus,
          cordinatorid: main.do_data || "",
          cordinatorName: main.cordinatorName || prev.cordinatorName || "",
          marginPercent: main.rcvd_mode2_amt || "",
        }));

        setDrAccount(main.cust_acc || "");
        setDrDesc(main.DrAccDesc || "");
        setCrAccount(main.salesacc || "");
        setCrDesc(main.salesAccDesc || "");
        setDiscountAmount(main.disc_amt || 0);
        setRoundOff(main.e || 0);

        const mappedItems = response.map((row, idx) => ({
          id: idx + 1,
          sino: idx + 1,
          code: row.code || row.do_icode || "",
          description: row.idesc || "",
          location: row.locn || currentLocation || "MAIN SHOP",
          unit: row.unit || row.punit || "",
          qty: row.tr_qty2 || row.tr_qty || row.so_qty || 0,
          unitCost: row.unit_cost?.toFixed(3) || "",
          unitPrice: row.unit_price?.toFixed(3) || "",
          discount: row.discount || 0,
          fraction: row.fraction != null ? String(row.fraction) : "1",
          "vat%": row.bcdisc || 0,
          cntrl: row.soGuid || row.it_slno || "",
          amount: row.line_total || row.fline_tota || 0,
          margin: Number(row.rcvd_mode2_amt) || Number(main.rcvd_mode2_amt) || BRANCH_TRANSFER_MARGIN_PERCENT,
          rcvd_qty: row.rcvd_qty,
          rcvd_amt: row.rcvd_mode1_amt,
          billed_amt: row.billed_amt,
          billed_qty: row.billed_qty
        }));

        setItems(mappedItems);
      }
    } catch (err) {
      console.error("Failed to fetch Sample Issue detail:", err);
    }
  };
  const initializeDocument = useCallback(async () => {
    try {
      const { voucherType, documentNo } = await fetchDocumentNumber(
        documentType,
        documentData.paymentMode,
        BASE_URL,
        COMPANY_CODE,
        DEPARTMENT,
      );

      if (documentNo) {
        setDocumentData((prev) => ({
          ...prev,
          documentNo: documentNo,
          voucherType,
        }));
      }
      console.log("Voucher Type:", voucherType, documentNo);
    } catch (err) {
      console.error("Error initializing document:", err);
    }
  }, [
    documentType,
    documentData?.paymentMode,
    BASE_URL,
    COMPANY_CODE,
    DEPARTMENT,
  ]);

  useEffect(() => {
    if (documentNoFromState && request) {
      fetchDocumentDetail(documentNoFromState);
    } else {
      // keep existing behavior for new mode
      setDocumentData((prev) => ({ ...prev, date: todayDate }));
    }
  }, [documentNoFromState]);

  useEffect(() => {
    if (mode === "new") {
      initializeDocument();
    }
  }, [mode, initializeDocument]);

  return (
    <div className="w-full relative">
      <div className="flex items-center justify-between lg:px-10 px-2 mb-2 gap-2">
        <div className="flex items-center gap-3">
          <h1 className="text-xl font-semibold">{transferConfig.title}</h1>

        </div>

        <Tooltip title={tooltipContent} sx={{ margin: 0, padding: 0 }}>
          <IconButton>
            <HelpOutline
              className="text-blue-600 bg-white rounded-full"
              fontSize="medium"
            />
          </IconButton>
        </Tooltip>
      </div>
      <ModeIndicator mode={mode} documentType={documentType} />
      <div className="w-full rounded-lg">
        <div className="lg:px-10">
          <div className="bg-gray-50 border lg:p-3 rounded-lg shadow pb-4">
            <ThemeProvider theme={theme}>
              <TabContext value={parentTabValue}>
                <Box
                  sx={{
                    borderBottom: 1,
                    borderColor: "divider",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <TabList onChange={handleParentTabChange}>
                    <Tab label="General" value="1" sx={{ padding: 0 }} />
                    <Tab label="Timeline" value="2" sx={{ padding: 0 }} />
                  </TabList>
                  <div className="lg:flex hidden items-center gap-3">
                    <button
                      onClick={() => {
                        navigate(
                          documentType === DOCUMENT_TYPES.STOCKTRANSFEROUT
                            ? "/sample_issue_list"
                            : documentType === DOCUMENT_TYPES.BRANCH_TRANSFER
                              ? "/branch_transfer_list"
                              : documentType === DOCUMENT_TYPES.BRANCH_TRANSFER_IN
                                ? "/branch_transfer_in_list"
                                : "/stock_transfer_in_list",
                        );
                      }}
                      className="flex items-center gap-2 px-5 py-2.5 border border-indigo-600 text-indigo-600 text-sm font-medium rounded-lg shadow hover:text-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-400 transition disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      <View className="w-4 h-4" />
                      View
                    </button>
                    <button
                      onClick={() => {
                        if (mode === "edit") {
                          setIsModificationModalOpen(true);
                        } else {
                          handleSave();
                        }
                      }}
                      disabled={mode === "view" || isSaving}
                      className="flex items-center gap-2 px-5 py-2.5 bg-green-500 text-white text-sm font-medium rounded-lg shadow hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-400 transition disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      {isSaving ? (
                        <>
                          <Loader className="w-4 h-4 animate-spin" />
                          Saving...
                        </>
                      ) : (
                        <>
                          <Save className="w-4 h-4" />
                          {mode === "edit" ? "Update" : "Save"}
                        </>
                      )}
                    </button>
                  </div>
                </Box>
                <TabPanel value="1" sx={{ p: 0, paddingX: 0 }}>
                  <StockTransferInGeneral
                    WorkOrderData={documentData}
                    setWorkOrderData={setDocumentData}
                    drAccount={drAccount}
                    setDrAccount={setDrAccount}
                    drDesc={drDesc}
                    setDrDesc={setDrDesc}
                    crAccount={crAccount}
                    setCrAccount={setCrAccount}
                    crDesc={crDesc}
                    setCrDesc={setCrDesc}
                    BASE_URL={BASE_URL}
                    COMPANY_CODE={COMPANY_CODE}
                    DEPARTMENT_NO={DEPARTMENT}
                    type={documentType}
                    setModalState={setModalState}
                    showBranchTransferModal={showBranchTransferModal}
                    setShowBranchTransferModal={setShowBranchTransferModal}
                    onBranchTransferSelected={handleBranchTransferSelected}
                  />
                </TabPanel>

                <TabPanel value="2" sx={{ p: 1 }}>
                  <TimelineTab
                    BASE_URL={BASE_URL}
                    DEPARTMENT={DEPARTMENT}
                    modificationType={MODIFICATION_TYPES[documentType] || null}
                    invoiceId={documentNoFromState}
                    COMPANY_CODE={COMPANY_CODE}
                  />
                </TabPanel>
              </TabContext>
            </ThemeProvider>
          </div>
        </div>
        {documentType !== DOCUMENT_TYPES.BRANCH_TRANSFER_IN && (
          <main className="w-full mt-4 relative">
            <StockTransferInTable
              items={items}
              onItemsChange={setItems}
              setShowSidebar={setShowSidebar}
              setFocusedProductCode={setFocusedProductCode}
              setCurrentLocation={setCurrentLocation}
              extraFields={[]}
              purchaseData={documentData}
              initialRowUnitOptions={initialRowUnitOptions}
              setInitialRowUnitOptions={setInitialRowUnitOptions}
              calculateWorkOrderRow={calculateRowValues}
              invoiceData={documentData}
              getVatPercent={getWorkOrderVatPercent}
              BASE_URL={BASE_URL}
              COMPANY_CODE={COMPANY_CODE}
              DEPARTMENT_NO={DEPARTMENT}
            />
            {checkIfUserHasAccess("FT") && (
              <FloatingItemInformation
                showSidebar={showSidebar}
                currentLocation={currentLocation}
                companyCode={COMPANY_CODE}
                API_BASE_URL={BASE_URL}
                productCode={focusedProductCode}
                department={DEPARTMENT}
                onStockInhandUpdate={setCurrentStockInhand}
                onItemInfoUpdate={setItemPricing}
              />
            )}
          </main>
        )}
        {/* Modal Data */}


        {/* Branch Transfer IN selected items table */}
        {documentType === DOCUMENT_TYPES.BRANCH_TRANSFER_IN && items && items.length > 0 && (
          <div className="w-full lg:px-10 p-1 mt-2">
            <div className="bg-white rounded-lg shadow border border-gray-200 p-4">
              <h2 className="text-lg font-semibold mb-2">Selected Branch Transfer Items</h2>
              <div className="overflow-x-auto">
                <table className="min-w-full border text-sm">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border px-2 py-1">SI No</th>
                      <th className="border px-2 py-1">Code</th>
                      <th className="border px-2 py-1">Description</th>
                      <th className="border px-2 py-1">Unit Price</th>
                      <th className="border px-2 py-1">Location</th>
                      <th className="border px-2 py-1">Unit</th>
                      <th className="border px-2 py-1">Qty</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((item, idx) => (
                      <tr key={item.id || idx}>
                        <td className="border px-2 py-1 text-center">{item.sino || idx + 1}</td>
                        <td className="border px-2 py-1">{item.code}</td>
                        <td className="border px-2 py-1">{item.description}</td>
                        <td className="border px-2 py-1 text-right">{item.unitPrice ?? item["unitPrice"] ?? item["Unit Price"] ?? 0}</td>
                        <td className="border px-2 py-1">
                          <select
                            value={item.location || currentLocation}
                            onChange={(e) => {
                              const updated = items.map((it) =>
                                it.id === item.id ? { ...it, location: e.target.value } : it,
                              );
                              setItems(updated);
                            }}
                            className="border border-gray-300 rounded px-1 py-0.5 text-sm w-full"
                          >
                            {locationList.map((loc) => (
                              <option key={loc.loc_code} value={loc.loc_code}>
                                {loc.loc_code} - {loc.DESC}
                              </option>
                            ))}
                          </select>
                        </td>
                        <td className="border px-2 py-1">{item.unit}</td>
                        <td className="border px-2 py-1 text-right">{item.qty}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {/* Modal Data */}

        {documentType === DOCUMENT_TYPES.BRANCH_TRANSFER || documentType === DOCUMENT_TYPES.BRANCH_TRANSFER_IN ? (
          <div className="w-full lg:px-10 p-1 mt-2">
            <div className="flex flex-col md:flex-row items-center justify-between p-4 bg-white rounded-lg shadow border border-gray-200 gap-4">
              <div className="flex flex-row items-center gap-4">
                <div className="text-lg font-semibold text-gray-700">
                  Total Amount:{" "}
                  <span className="text-2xl font-bold text-blue-600">
                    {documentType === DOCUMENT_TYPES.BRANCH_TRANSFER_IN ? totals.simpleTotal : totals.netAmount}
                  </span>
                </div>
                <div className="text-lg font-semibold text-gray-700">
                  Total Cost:{" "}
                  <span className="text-2xl font-bold text-green-600">
                    {documentType === DOCUMENT_TYPES.BRANCH_TRANSFER_IN ? totals.simpleTotal : totals.costAmountTotal}
                  </span>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <button
                  onClick={() => {
                    if (mode === "edit") {
                      setIsModificationModalOpen(true);
                    } else {
                      handleSave();
                    }
                  }}
                  disabled={mode === "view" || isSaving}
                  title={mode === "view" ? "Disabled in view mode" : ""}
                  className="flex items-center gap-2 px-6 py-2.5 bg-green-500 text-white text-sm font-medium rounded-lg shadow hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-400 transition disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isSaving ? (
                    <>
                      <Loader className="w-4 h-4 animate-spin" />
                      Saving...
                    </>
                  ) : (
                    <>
                      <Save className="w-4 h-4" />
                      {mode === "edit" ? "Update" : "Save"}
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="w-full lg:px-10 p-1 mt-2">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-start">
              <ConfigCard
                invoiceData={documentData}
                setAutoVatIsOn={setAutoVatIsOn}
                setInvoiceData={setDocumentData}
                autoVatIsOn={autoVatIsOn}
                documentType={documentType}
                config={config}
                setIsModalOpen={setIsTransferModalOpen}
                isModalOpen={transferModalOpen}
                invoiceNoFromState={documentNoFromState}
                accountData={supplierData}
              />

              <SummaryTotalCard
                totals={totals}
                setInvoiceData={setDocumentData}
                invoiceData={documentData}
                handlePrint={handlePrint}
                handleSave={handleSave}
                roundOff={roundOff}
                setRoundOff={setRoundOff}
                discountAmount={discountAmount}
                setDiscountAmount={setDiscountAmount}
                mode={mode}
                autoVatIsOn={autoVatIsOn}
                setVatAmountManual={setVatAmountManual}
                config={config}
                setIsModificationModalOpen={setIsModificationModalOpen}
              />
            </div>
          </div>
        )}
      </div>
      <Modal
        isOpen={isModificationModalOpen}
        onClose={() => setIsModificationModalOpen(false)}
        size="md"
        header={true}
        title="Update Confirmation"
        showFullScreen={false}
      >
        <ModificationCommentModal
          isOpen={isModificationModalOpen}
          onClose={() => setIsModificationModalOpen(false)}
          handleSave={handleSave}
          documentData={documentData}
          documentType={documentType}
          COMPANY_CODE={COMPANY_CODE}
          DEPARTMENT={DEPARTMENT}
          CURRENT_USER={CURRENT_USER}
          BASE_URL={BASE_URL}
          setIsModificationModalOpen={setIsModificationModalOpen}
        />
      </Modal>
      <Modal
        isOpen={modalState.isOpen}
        onClose={closeModal}
        title={
          modalState.type === "job-list"
            ? "Select Job Code"
            : modalState.type === "cost-center-list"
              ? "Select Cost Center"
              : "Select Customer"
        }
        size={
          modalState.type === "job-list"
            ? "xxl"
            : "credit-customer"
              ? "xxl"
              : "md"
        }
        header={modalState.type === "add" ? false : true}
      >
        {modalState.type === "job-list" && (
          <JobCodeList
            open={modalState.isOpen}
            onClose={closeModal}
            BASE_URL={BASE_URL}
            COMPANY_CODE={COMPANY_CODE}
            onSelect={(job) => {
              setDocumentData({
                ...documentData,
                job: job.JobCode,
              });
              closeModal();
            }}
          />
        )}
        {modalState.type === "cost-center-list" && (
          <JobCodeList
            open={modalState.isOpen}
            onClose={closeModal}
            BASE_URL={BASE_URL}
            COMPANY_CODE={COMPANY_CODE}
            onSelect={(job) => {
              setDocumentData({
                ...documentData,
                costCenter: job.JobCode,
              });
              closeModal();
            }}
          />
        )}
        {modalState.type === "credit-customer" && (
          <CreditCustomerList
            showSidebar={true}
            handleCustomerSelect={handleCreditCustomerSelect}
            defaultType={modalState.defaultType || "All"}
          />
        )}
      </Modal>
      <Modal
        isOpen={showBranchTransferModal}
        onClose={() => setShowBranchTransferModal(false)}
        size="xl"
        header={true}
        title="Branch Transfer Doc List"
        showFullScreen={false}
      >
        <BranchTransferDocListModal
          isOpen={showBranchTransferModal}
          onClose={() => setShowBranchTransferModal(false)}
          BASE_URL={BASE_URL}
          COMPANY_CODE={COMPANY_CODE}
          DEPARTMENT={DEPARTMENT}
          crAccount={crAccount}
          onBranchTransferSelected={handleBranchTransferSelected}
        />
      </Modal>


    </div>
  );
};

export default StockTransfer;
